import { HIDDEN_FIELDS_CONFIG } from "./hiddenFieldsConfig";
type GtmEvent = Record<string, string>;

// Mutates the event object!
function addDataFieldsToEvent(event: Record<string, any>, dataFields: Array<string>, source: Record<string, any>) {
	// make sure that all is utf-8 encoded and correct escaping (if there is % in the field for example).
	dataFields.forEach(field => (event[field] = source[field]));
}

export function createGtmEvent(
	eventType: string,
	data?: Record<string, any>,
	hiddenData?: Record<string, any>,
): GtmEvent | null | undefined {
	if (!data) {
		return null;
	}

	const event = {
		solution: "M:Shop",
		userInterface: "responsive-site",
		event: eventType,
		isGTMEvent: "true",
	};
	const eventConfig = HIDDEN_FIELDS_CONFIG[eventType];

	if (!eventConfig) {
		addDataFieldsToEvent(event, Object.keys(data) || [], data);

		if (hiddenData) {
			addDataFieldsToEvent(event, Object.keys(hiddenData) || [], hiddenData);
		}

		return event;
	}

	const eventDescription = data[eventConfig.eventTypeSource];
	const fieldsConfig = eventConfig.trackingFieldNames[eventDescription]
		? eventConfig.trackingFieldNames[eventDescription]
		: eventConfig.trackingFieldNames["default"];

	if (!fieldsConfig) {
		return null;
	}

	// Information all events contain.
	event.event = eventConfig.gtmEventName;
	addDataFieldsToEvent(event, fieldsConfig.data || [], data);
	addDataFieldsToEvent(event, fieldsConfig.hidden || [], hiddenData || {});
	return event;
}
